import { create } from 'zustand';

export type SelectTalentStore = {
  isModalOpen: boolean;
  setIsModalOpen: (isModalOpen: boolean) => void;
  reset: () => void;
};

export const useSelectTalentStore = create<SelectTalentStore>((set) => ({
  isModalOpen: false,
  setIsModalOpen: (isModalOpen) => set({ isModalOpen }),

  reset: () =>
    set({
      isModalOpen: false,
    }),
}));
